import React, { useEffect } from "react";
import { MixmindUniverse, useUniverse } from "../../context/UniverseContext";

export default function AcademyResources() {
  const { setUniverse } = useUniverse();
  useEffect(() => {
    setUniverse(MixmindUniverse.Academy);
  }, [setUniverse]);

  return (
    <div className="max-w-5xl mx-auto space-y-4">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Ressources</h1>
        <p className="text-sm md:text-base text-slate-600 dark:text-slate-300">
          Ressources pédagogiques (placeholder à compléter).
        </p>
      </header>
    </div>
  );
}
